export default __webpack_public_path__ + "static/revista_digital-8f6c792f1cfb27a12bafdc713fbc1d6a.pdf";